import React from 'react';
import './ProduktList.css';

export default function ProduktList(props) {
    const produkt = props.produkt;
    let classd="";
    if(produkt.dostepny==="f")
    {
        classd="produkt-niedostepny bg-danger";
    }
    return (
     <tr className={"tabela shadow-sm "+classd} >
            <td className="td-img">
                <img alt="a" style={{ maxWidth: 180 + 'px', minWidth: 180 + 'px' }} src={produkt.logo_url} />
            </td>
            <td className="rty">
                <a href={process.env.PUBLIC_URL+"/produkt/" + produkt.id_produkt}><h5 className="m-0 p-0">{produkt.nazwa}</h5></a>
                Marka: <strong>{produkt.marka}</strong>
                <br />EAN: <strong><a target="_blank" href={"https://www.eprodukty.gs1.pl/catalog/0"+produkt.ean}>{produkt.ean}</a></strong>
                <br />nr kat:<strong>{produkt.nr_katalogowy}</strong>
            </td>
            <td className="qwe">{produkt.opis_krotki}</td>
        </tr>
    );
}
